import React, { useState, useEffect, useRef } from "react";
import { Box, Stack, Typography, Button, Grid } from "@mui/material";
import { X } from "@phosphor-icons/react";
import CreatableSelect from "react-select/creatable";
import { Input as BaseInput } from "@mui/base/Input";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import { EditorProvider } from "@tiptap/react";
import { Color } from "@tiptap/extension-color";
import ListItem from "@tiptap/extension-list-item";
import TextStyle from "@tiptap/extension-text-style";
import Mention from "@tiptap/extension-mention";
import Image from "@tiptap/extension-image";
import Text from "@tiptap/extension-text";
import { connect } from "react-redux";
import {
  setShowEmailList,
  setMentionList,
  fetchEmailList,
  SelectTemplate,
  clearAttachmentItem2,
  fetchFromEmailList,
  GetAllUsers,
  setComposeAttachment,
} from "../../Redux/Actions/actions";
import Document from "@tiptap/extension-document";
import Gapcursor from "@tiptap/extension-gapcursor";
import TextAlign from "@tiptap/extension-text-align";
import StarterKit from "@tiptap/starter-kit";
import suggestion from "../chat-components/Chat-component/EmailBodyComponent/EditorProps/Suggestion";
import ComposeMenubar from "./ComposeMenubar";
import { ResizableImage } from "../chat-components/Chat-component/EmailBodyComponent/EditorProps/ResizeFiles";
import {
  Video,
  Pdf,
  ReplayMail,
} from "../chat-components/Chat-component/EmailBodyComponent/EditorProps/CustomeNode";
import FileHandler from "@tiptap-pro/extension-file-handler";
import {
  fileTypeToIcon,
  formatFileSize,
} from "../Utils/Email-utils/email-utils";
import MenuList from "../chat-components/Chat-component/EmailBodyComponent/EmailTypes/MenuList";
import { BaseUrl } from "../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import { toaststyle } from "../../Utils/toaststyle";
import { toast } from "react-toastify";

// subject custome input component
const Input = React.forwardRef(function CustomInput(props, ref) {
  return <BaseInput slots={{ input: InputElement }} {...props} ref={ref} />;
});
const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};
const InputElement = styled("input")(
  ({ theme }) => `
      width: 100%;
      font-family: 'IBM Plex Sans', sans-serif;
      font-size: 13px;
      font-weight: 400;
      line-height: 1.5;
      padding: 7px 12px;
      border-radius: 2px;
      color: ${grey[900]};
      background: ${"#fff"};
      border: 0px solid ${grey[200]};
      border-top:none;
      border-right:none;
      border-left:none;
      &:hover {
        border-top:none;
        border-right:none;
        border-left:none;
      }
   
    
      &:focus-visible {
        outline: 0;
        border-top:none;
        border-right:none;
        border-left:none;
      }
    `
);
const style = {
  control: (base, state) => ({
    ...base,
    border: state.isFocused ? 0 : 0,
    boxShadow: state.isFocused ? 0 : 0,
    "&:hover": {
      border: state.isFocused ? 0 : 0,
      borderBottom: "0 px solid #c6c6c6b8",
      borderRadius: "0px",
    },
    borderBottom: "0px solid #c6c6c6b8",
    minHeight: "30px",
    fontSize: "13px",
  }),

  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    display: "none",
  }),
  multiValue: (styles) => {
    return {
      ...styles,
      borderRadius: "20px",
    };
  },
  multiValueRemove: (styles) => ({
    ...styles,
    ":hover": {
      ...styles,
      borderRadius: "20px",
    },
  }),
};
const mapStateToProps = (state) => {
  return {
    showEmailList: state.email.showEmailList,
    selectedMail: state.email.selectedMail,
    emailListOption: state.email.emailListOption,
    templatelist: state.email.templatelist,
    composeAttachment: state.email.composeAttachment,
    fromEmailList: state.email.fromEmailList,
  };
};

const ComposeNewEmailComponent = (props) => {
  const { showComposeMail, setshowComposeMail } = props;
  const [html, setHTML] = useState(``);
  const [from, setFrom] = useState([]);
  const [to, setto] = useState([]);
  const [Cc, setCc] = useState([]);
  const [Bcc, setBcc] = useState([]);
  const [subject, setsubject] = useState("");
  const [showCc, setshowCc] = useState(false);
  const [showBcc, setshowBcc] = useState(false);

  const handleComposeMail = async () => {
    if (!html) return;
    // this will convert all object list to array list
    const agentId = JSON.parse(localStorage.getItem("tokenAgent"));
    const fromemail = from.map((item) => item.value);
    const toemail = to.map((item) => item.value);
    const Ccemail = Cc.map((item) => item.value);
    const Bccemail = Bcc.map((item) => item.value);
    const composeAttachment = props.composeAttachment.map((item) => {
      return {
        url: item.attachmentUrl,
        download: item.filename,
      };
    });

    let formdata = new FormData();
    formdata.append("fromemail", fromemail);
    formdata.append("toemail", toemail);
    formdata.append("ccData", Ccemail);
    formdata.append("bccData", Bccemail);
    formdata.append("subject", subject);
    formdata.append("skillset", "Wc_Inaipi");
    formdata.append("attachmentUrls", JSON.stringify(composeAttachment));
    formdata.append("html", html);
    formdata.append("agent_id", agentId.agent_id);
    await axios
      .post(BaseUrl + "/email/composeemail", formdata, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        console.log("compose email", res);
        if (res.data.status) {
          toast.success(res.data.message, toaststyle);
          setshowComposeMail(false);
          props.GetAllUsers();
          props.setComposeAttachment([]);
          setHTML();
          setFrom([]);
          setto([]);
          setCc([]);
          setBcc([]);
          setsubject("");
        } else {
          toast.error(res.data.message, toaststyle);
        }
      })
      .catch((error) => {
        console.log("SendMail", error);
      });
  };

  useEffect(() => {
    props.fetchEmailList();
    props.fetchFromEmailList();
  }, []);

  return (
    <Box
      sx={{
        position: "absolute",
        background: "#FFFFFF",
        width: "550px",
        height: "auto",
        right: "60px",
        bottom: "1px",
        zIndex: 9999,
        borderRadius: "8px 8px 0 0",
        boxShadow:
          "0px 8px 10px 1px rgba(0,0,0,.14),0px 3px 14px 2px rgba(0,0,0,.12),0px 5px 5px -3px rgba(0,0,0,.2)",
      }}
    >
      <Box
        sx={{
          background: "#F2F6FC",
          height: "40px",
          padding: "10px 15px",
        }}
      >
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Typography variant="subtitle" sx={{ fontWeight: 600 }}>
            New Message
          </Typography>
          <X
            size={15}
            weight="bold"
            color="#444746"
            cursor="pointer"
            onClick={() => {
              setshowComposeMail(false);
              document.title = "Inaipi-Digital";
            }}
          />
        </Stack>
      </Box>

      <Stack sx={{ height: "calc(100% - 40px)", width: "100%" }}>
        <Box p={1}>
          <Stack spacing={0.5} sx={{ width: "100%" }}>
            <CreatableSelect
              isFocused
              value={from}
              isMulti
              name="colors"
              placeholder="From..."
              components={{ MenuList }}
              options={props.fromEmailList}
              className="basic-multi-select"
              classNamePrefix="select"
              onChange={(e) => {
                setFrom(e);
              }}
              styles={style}
            />
            <Stack direction={"row"} spacing={1} alignItems={"center"}>
              <CreatableSelect
                value={to}
                isMulti
                name="colors"
                placeholder="To..."
                components={{ MenuList }}
                options={props.emailListOption}
                className="basic-multi-select"
                classNamePrefix="select"
                onChange={(e) => {
                  setto(e);
                }}
                styles={style}
              />

              {Bcc.length == 0 && Cc.length == 0 && !showCc && !showBcc && (
                <span
                  className="composeEmail-cc-bcc"
                  onClick={() => {
                    setshowCc(true);
                  }}
                >
                  Cc
                </span>
              )}
              {Bcc.length == 0 && Cc.length == 0 && !showCc && !showBcc && (
                <span
                  className="composeEmail-cc-bcc"
                  onClick={() => {
                    setshowBcc(true);
                  }}
                >
                  Bcc
                </span>
              )}
            </Stack>

            {(showCc || Cc.length > 0) && (
              <Stack direction={"row"} spacing={1} alignItems={"center"}>
                <CreatableSelect
                  autoFocus
                  defaultValue={[]}
                  value={Cc}
                  isMulti
                  name="colors"
                  placeholder="Cc..."
                  components={{ MenuList }}
                  options={props.emailListOption}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  onChange={(e) => {
                    setCc(e);
                  }}
                  onBlur={() => setshowCc(false)}
                  styles={style}
                />
                {Bcc.length == 0 && !showBcc && (
                  <span
                    className="composeEmail-cc-bcc"
                    onClick={() => {
                      setshowBcc(true);
                    }}
                  >
                    Bcc
                  </span>
                )}
              </Stack>
            )}
            {(showBcc || Bcc.length > 0) && (
              <Stack direction={"row"} spacing={1} alignItems={"center"}>
                <CreatableSelect
                  autoFocus
                  defaultValue={[]}
                  value={Bcc}
                  isMulti
                  name="colors"
                  placeholder="Bcc..."
                  components={{ MenuList }}
                  options={props.emailListOption}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  onChange={(e) => {
                    setBcc(e);
                  }}
                  styles={style}
                  onBlur={() => setshowBcc(false)}
                />
                {Cc.length == 0 && !showCc && (
                  <span
                    className="composeEmail-cc-bcc"
                    onClick={() => {
                      setshowCc(true);
                    }}
                  >
                    Cc
                  </span>
                )}
              </Stack>
            )}

            <Input
              value={subject}
              aria-label="Demo input"
              type="text"
              placeholder="Subject..."
              onChange={(e) => {
                setsubject(e.target.value);
              }}
            />
          </Stack>

          {props.composeAttachment.length > 0 && (
            <Box
              p={1}
              sx={{
                height: "100px",
                display: "flex",
                flexDirection: "row",
                gap: "5px",
              }}
            >
              <Box
                className="CONTACT-LIST-AREA"
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography variant="caption">ATTACHMENT</Typography>
              </Box>
              <Box
                className="CONTACT-LIST-AREA"
                sx={{
                  overflowY: "scroll",
                }}
              >
                <div className="attachment-container">
                  {props.composeAttachment.length > 0
                    ? props.composeAttachment.map((data, index) => {
                        const icon = fileTypeToIcon[data.fileType];
                        return (
                          <Box
                            sx={{
                              width: "max-content",
                              padding: "5px",
                              border: "1px solid #cfcfcf",
                            }}
                            key={index}
                          >
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              spacing={0.5}
                            >
                              <img
                                src={icon}
                                alt="File Icon"
                                width="20px"
                                height="20px"
                              />
                              <Stack spacing={0.4}>
                                <Typography
                                  variant="caption"
                                  noWrap
                                  sx={{ width: "70px" }}
                                >
                                  {data.filename}
                                </Typography>
                                <div className="file-size">
                                  {formatFileSize(data.filesize)}
                                </div>
                              </Stack>
                              <div className="dropdown-icon">
                                <CloseIcon
                                  sx={{ color: "#b2b2b2" }}
                                  onClick={() => {
                                    props.clearAttachmentItem2(
                                      props.composeAttachment,
                                      index
                                    );
                                  }}
                                />
                              </div>
                            </Stack>
                          </Box>
                        );
                      })
                    : null}
                </div>
              </Box>
            </Box>
          )}
        </Box>

        <Box
          className="compose-mail"
          sx={{
            flexGrow: 1,
            boxSizing: "border-box",
            width: "100%",
          }}
          p={1}
        >
          <EditorProvider
            slotAfter={<ComposeMenubar handleComposeMail={handleComposeMail} />}
            extensions={[
              Document,
              Text,
              Gapcursor,
              ReplayMail,
              Pdf,
              Video,
              Image,
              ResizableImage,
              Color.configure({ types: [TextStyle.name, ListItem.name] }),
              TextStyle.configure({ types: [ListItem.name] }),
              Mention.configure({
                HTMLAttributes: { class: "mention" },
                suggestion,
              }),
              StarterKit.configure({
                bulletList: {
                  keepMarks: true,
                  keepAttributes: false,
                },
                orderedList: {
                  keepMarks: true,
                  keepAttributes: false,
                },
              }),
              TextAlign.configure({
                types: ["heading", "paragraph", "image", "video"],
              }),
              Image.configure({
                inline: true,
                allowBase64: true,
              }),
              FileHandler.configure({
                onDrop: (currentEditor, files, pos) => {
                  files.forEach((file) => {
                    const fileReader = new FileReader();
                    if (file.type.startsWith("image/")) {
                      fileReader.readAsDataURL(file);
                      fileReader.onload = () => {
                        currentEditor
                          .chain()
                          .insertContentAt(pos, {
                            type: "image",
                            attrs: {
                              src: fileReader.result,
                            },
                          })
                          .focus()
                          .run();
                      };
                    } else if (
                      file.type.startsWith("application/") ||
                      file.type.startsWith("text/")
                    ) {
                      fileReader.readAsDataURL(file);
                      fileReader.onload = () => {
                        currentEditor
                          .chain()
                          .insertContentAt(pos, {
                            type: "pdf",
                            attrs: {
                              src: fileReader.result,
                              title: file.name,
                            },
                          })
                          .focus()
                          .run();
                      };
                    } else if (file.type.startsWith("video/")) {
                      fileReader.readAsDataURL(file);
                      fileReader.onload = () => {
                        currentEditor
                          .chain()
                          .insertContentAt(pos, {
                            type: "video",
                            attrs: {
                              src: fileReader.result,
                            },
                          })
                          .focus()
                          .run();
                      };
                    } else {
                      console.warn("Unsupported file type:", file.type);
                    }
                  });
                },
                onPaste: (currentEditor, files, htmlContent) => {
                  console.log("files types", files);
                  files.forEach((file) => {
                    if (htmlContent) {
                      console.log(htmlContent);
                      return false;
                    }

                    const fileReader = new FileReader();

                    if (file.type.startsWith("image/")) {
                      fileReader.readAsDataURL(file);
                      fileReader.onload = () => {
                        currentEditor
                          .chain()
                          .insertContentAt(
                            currentEditor.state.selection.anchor,
                            {
                              type: "image",
                              attrs: {
                                src: fileReader.result,
                              },
                            }
                          )
                          .focus()
                          .run();
                      };
                    } else if (
                      file.type.startsWith("application/") ||
                      file.type.startsWith("text/")
                    ) {
                      fileReader.readAsDataURL(file);
                      fileReader.onload = () => {
                        currentEditor
                          .chain()
                          .insertContentAt(
                            currentEditor.state.selection.anchor,
                            {
                              type: "pdf",
                              attrs: {
                                src: fileReader.result,
                                title: file.name,
                              },
                            }
                          )
                          .focus()
                          .run();
                      };
                    } else if (file.type.startsWith("video/")) {
                      fileReader.readAsDataURL(file);
                      fileReader.onload = () => {
                        currentEditor
                          .chain()
                          .insertContentAt(
                            currentEditor.state.selection.anchor,
                            {
                              type: "video",
                              attrs: {
                                src: fileReader.result,
                              },
                            }
                          )
                          .focus()
                          .run();
                      };
                    } else {
                      console.warn("Unsupported file type:", file.type);
                    }
                  });
                },
              }),
            ]}
            onUpdate={({ editor }) => {
              setHTML(editor.getHTML());
            }}
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default connect(mapStateToProps, {
  setShowEmailList,
  setMentionList,
  fetchEmailList,
  fetchFromEmailList,
  SelectTemplate,
  clearAttachmentItem2,
  GetAllUsers,
  setComposeAttachment,
})(ComposeNewEmailComponent);
